import * as React from 'react'
import { ReactElement } from 'react'
import { DocumentNodeType, DocumentType, formatDocumentNodeName } from '../../helpers/documentHelper'
import IconValue, { IconValueProps } from '../IconValue/IconValue'
import { getApplicationIconPropsByFileName, getApplicationIconPropsByType } from '../../helpers/iconHelper'
import { FileTypeIconSize } from '@fluentui/react-file-type-icons'
import StealthLink from '../../components/StealthLink'
import { Destination } from '../../context/AxiosContext'

type Props = {
    id?: string
    name: string
    isLink?: boolean
    url?: string
    nodeType?: DocumentNodeType
    type?: DocumentType
    iconValueProps?: Omit<IconValueProps, 'iconProps'>
    iconSize?: FileTypeIconSize
}

const getType = (props: Props): DocumentType => {
    if (props.type) {
        return props.type
    } else if (props.nodeType === DocumentNodeType.Folder) {
        return DocumentType.Folder
    }

    return undefined
}

export default function DocumentName(props: Props): ReactElement {
    const type = getType(props)
    const name = formatDocumentNodeName(props.name, props.nodeType)
    const iconProps = type
        ? getApplicationIconPropsByType(type, props.iconSize)
        : getApplicationIconPropsByFileName(props.name, props.iconSize)

    return (
        <IconValue
            {...props.iconValueProps}
            iconProps={iconProps}
            value={
                <StealthLink id={props.isLink && props.id} url={props.url} destination={Destination.Documents}>
                    {name}
                </StealthLink>
            }
        ></IconValue>
    )
}
